import { render, staticRenderFns } from "./park-passage.vue?vue&type=template&id=a94f77dc&scoped=true&"
import script from "./park-passage.vue?vue&type=script&lang=js&"
export * from "./park-passage.vue?vue&type=script&lang=js&"
import style0 from "./park-passage.vue?vue&type=style&index=0&id=a94f77dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94f77dc",
  null
  
)

export default component.exports